import axios from 'axios';
import { DTOAddressKorea, DTOAddressKoreaRaw, DTOLocation, DTOLocationRaw } from 'Services/v1/locations/dto';
import { PAGESIZE } from 'Utilities/constants';
import { CamelSnakeMapper } from '../../data-mappers';
import httpClient from '../../http-client';
import { DTOResponseMetaData, DTOResponseMetaDataRaw, DTOServiceResponse } from '../../interfaces';
import RootServiceV1 from '../root';
import config from '../../../../config/config';


class LocationServiceV1 extends RootServiceV1 {
  constructor() {
    super();
  }

  async getLocations(
    id: string | number
  ): Promise<DTOServiceResponse<DTOLocation>> {
    try {
      const APP_VERSION =  config.appVersion ?? 'v1';
      const CACHE_PREFIX = `${APP_VERSION}_location_cache_`;
      const cacheKey = `${CACHE_PREFIX}${id}`;

      // 1️⃣ check localStorage
      if (typeof window !== 'undefined') {
        const stored = localStorage.getItem(cacheKey);
        if (stored) {
          return {
            statusCode: 200,
            data: JSON.parse(stored),
          };
        }
      }

      // 2️⃣ call API
      const response = await httpClient().get('v2/get_location', {
        params: {
          locId: id,
        },
      });

      const data = CamelSnakeMapper.toCamelCase<
        DTOLocationRaw,
        DTOLocation
      >(response.data);

      // 3️⃣ save cache
      if (typeof window !== 'undefined') {
        localStorage.setItem(cacheKey, JSON.stringify(data));

        // 4️⃣ enforce cache limit (200)
        const keys = Object.keys(localStorage).filter(k =>
          k.startsWith(CACHE_PREFIX)
        );

        if (keys.length > 200) {
          // remove oldest (FIFO)
          localStorage.removeItem(keys[0]);
        }
      }

      return {
        statusCode: 200,
        data,
      };
    } catch (err) {
      const parsedError = this._errorParser(err);
      return {
        statusCode: parsedError.statusCode,
        error: parsedError,
      };
    }
  }


  async getLocationsByAddress(address: string) {
    try {
      const a = axios.create({
        baseURL: "https://maps.googleapis.com/maps/api/",
        headers: {
          'Content-Type': 'application/json'
        },
      });
      const response = await a.get('geocode/json', {
        params: { address, key: 'AIzaSyB28k55rvVd3MUokqBdH-N3ct2ACTD7B54' }
      });
      return {
        statusCode: 200,
        data: CamelSnakeMapper.toCamelCase<DTOLocationRaw, DTOLocation>(response.data)
      };
    } catch (err) {
      const parsedError = this._errorParser(err);
      return {
        statusCode: parsedError.statusCode,
        error: parsedError,
      };
    }
  }

  async getAddressKorea(
		id: string | number,
    pageIndex: number,
    txtSearch: string
	): Promise<DTOServiceResponse<DTOAddressKorea[]>> {
		try {
			const response = await httpClient().get('/v1/order/address-korea' , {
        params: {
          loc_id: id,
          page: pageIndex,
          page_size: PAGESIZE,
          search: txtSearch
        }
      });
			const data = response.data.data;
      const meta = response.data.meta;
			return {
				statusCode: 200,
				data: data.map(CamelSnakeMapper.toCamelCase<DTOAddressKoreaRaw, DTOAddressKorea>),
        meta: CamelSnakeMapper.toCamelCase<DTOResponseMetaDataRaw, DTOResponseMetaData>(meta)
			};
		} catch (err) {
			const parsedError = this._errorParser(err);
			return {
				statusCode: parsedError.statusCode,
				error: parsedError,
			};
		}
	}

}

export default (new LocationServiceV1()) as LocationServiceV1;
